import { API_CREATE_FAVORITE, API_CREATE_FAVORITE_SUCCESS, API_DELETE_FAVORITE, API_DELETE_FAVORITE_MANY, API_DELETE_FAVORITE_MANY_SUCCESS, API_DELETE_FAVORITE_SUCCESS, } from '../actions/FavoriteActions';
import { API_GET_LIST_SEARCH_SOLUTION_MORE_SUCCESS, API_GET_LIST_SEARCH_SOLUTION_SUCCESS, SEARCH_SOLUTION_PARAM_REPLACE, SEARCH_SOLUTION_PARAM_SET, SEARCH_SOLUTION_PRE_KEYWORD_SET, SEARCH_SOLUTION_VIEW_REPLACE, SEARCH_SOLUTION_VIEW_SET, } from '../actions/SearchSolutionActions';
import { updateFavoriteList } from '../helpers/favorite';
const initialState = {
    lastQuery: '',
    list: [],
    params: {},
    preKeyword: '',
    total: 0,
    views: {},
};
export default (
// eslint-disable-next-line default-param-last
state = Object.assign({}, initialState), { meta, payload, total, type }) => {
    switch (type) {
        // 検索結果の反映
        case API_GET_LIST_SEARCH_SOLUTION_SUCCESS: {
            return Object.assign(Object.assign({}, state), { lastQuery: meta.lastQuery, list: payload.list, page: 1, total });
        }
        // VIEW MOREの反映
        case API_GET_LIST_SEARCH_SOLUTION_MORE_SUCCESS: {
            return Object.assign(Object.assign({}, state), { list: [...state.list, ...payload.list], page: meta.page });
        }
        // お気に入りの反映
        case API_CREATE_FAVORITE:
        case API_DELETE_FAVORITE:
        case API_CREATE_FAVORITE_SUCCESS:
        case API_DELETE_FAVORITE_SUCCESS:
        case API_DELETE_FAVORITE_MANY:
        case API_DELETE_FAVORITE_MANY_SUCCESS: {
            updateFavoriteList(state.list, meta, payload, type);
            return Object.assign({}, state);
        }
        case SEARCH_SOLUTION_PARAM_REPLACE: {
            return Object.assign(Object.assign({}, state), { params: Object.assign({}, payload) });
        }
        case SEARCH_SOLUTION_PARAM_SET: {
            return Object.assign(Object.assign({}, state), { params: Object.assign(Object.assign({}, (state.params || {})), payload) });
        }
        case SEARCH_SOLUTION_VIEW_SET: {
            return Object.assign(Object.assign({}, state), { views: Object.assign(Object.assign({}, (state.views || {})), payload) });
        }
        case SEARCH_SOLUTION_VIEW_REPLACE: {
            return Object.assign(Object.assign({}, state), { views: Object.assign({}, payload) });
        }
        case SEARCH_SOLUTION_PRE_KEYWORD_SET: {
            return Object.assign(Object.assign({}, state), { preKeyword: payload });
        }
        default: {
            return state;
        }
    }
};
